export default "__VITE_ASSET__Buw7xAER__"